import {
    POS_DASHBOARD_GO_BUTTON_ACTION,
    POS_DASHBOARD_GO_BUTTON_SUCCESS,
    POS_DASHBOARD_API_ERROR_ACTION,
  } from "./actionType";
  
  export const PosDashboard_Report_Action = (config = {}) => ({
    type: POS_DASHBOARD_GO_BUTTON_ACTION,
    config,
  });
  
  export const PosDashboard_GoButton_Success = (resp) => ({
    type: POS_DASHBOARD_GO_BUTTON_SUCCESS,
    payload: resp,
  });
  
  export const PosDashboard_ApiErrorAction = () => ({
    type: POS_DASHBOARD_API_ERROR_ACTION,
  });
  